module.exports = __webpack_public_path__ + "static/media/image_5.2a035543.png";